import { Controller } from '@hotwired/stimulus'

// Points a "back to list" link to the last visited (filtered) list URL,
// saved by list_return_controller while browsing the index page.
export default class extends Controller {
  static values = { key: String }

  connect() {
    const saved = sessionStorage.getItem(`backUrl:${this.keyValue}`)
    if (saved) this.element.setAttribute('href', saved)
  }
}
